import { createReducers } from 'redux/utils'
import { dataGridReducer } from 'redux/dataGrid'

export const BLOG_LIST = 'blogList'
export const IMAGES_LIST = 'imagesList'
export const DOWNLOADED_LIST = 'downloadedList'
export const FAVOURITES_LIST = 'favouritesList'
export const TRANSFERS_LIST = 'transfersList'
export const INVOICES_LIST = 'invoicesList'
export const TAGS_LIST = 'tagsList'
export const CATEGORIES_LIST = 'categoriesList'
export const SAME_SERIES = 'sameSeriesList'
export const SIMILAR_LIST = 'similarList'
export const BEST_LIST = 'bestList'

export const dataGridReducers = createReducers(dataGridReducer, [
  BLOG_LIST,
  IMAGES_LIST,
  TAGS_LIST,
  CATEGORIES_LIST,
  SAME_SERIES,
  SIMILAR_LIST,
  BEST_LIST,
  DOWNLOADED_LIST,
  FAVOURITES_LIST,
  INVOICES_LIST,
  TRANSFERS_LIST,
])
